import { combineReducers } from 'redux'
import productReducer from "./products";
import { cartReducer } from "./cart";
import { wishListReducer } from "./wishList";
import compareListReducer from "./compare";
import cartAPIReducer from "./cartAPI";
import authReducer from "./auth";

const rootReducer = combineReducers({
    data: productReducer,
    cartList: cartReducer,
    cartAPI: cartAPIReducer,  // Carrello integrato con backend
    wishList: wishListReducer,
    compareList: compareListReducer,
    auth: authReducer,        // Autenticazione utente
});

export default rootReducer;
